/* Version 3.0.29 */
/*global $:false */
var InFlight = InFlight || {};
InFlight.NLX = InFlight.NLX || {};
InFlight.NLX.Cfg = InFlight.NLX.Cfg || {};
var InFlightDCType;
(function ($) {
    var unloaded = false;

    window.addEventListener('beforeunload', function(event) {
        unloaded = true;
    });

    var numLoading = 0; //number of outstanding calls to numLoading

    InFlightDCType = function (useSPA) {
        'use strict';

        if (typeof useSPA === 'undefined') {
            useSPA = true;
        }

        /**
         * window Global ifReferenceWindow Object
         *
         */
        if (useSPA) {
            self.window.ifReferenceWindow = self.window.ifReferenceWindow || window;
        }

        /**
         * InFlightDCType Variables
         *
         */
        var config = {},
            CURRENTDOCUMENT = null,
            DATA_PREFIX = 'ifDefault_',
            NLX_NULL_ATTRIBUTE = '$$NLX_NULL$$',
            MAINTENANCE_PAGE = '/pages/maintenance.html';

        if (useSPA) {
            CURRENTDOCUMENT = self.window.ifReferenceWindow.document;
        }

        /**
         * Defines the default.sourceContextSelector if nlx.sourceContext
         * is set and if nlx.ContentSourceOverride is set.
         *
         */
        Object.defineProperty(config, 'sourceContextSelector', {
            get: function () {
                var outputSelector = '';
                if (this.sourceContext && $('[data-if-context-wrapper=\"' + this.sourceContext + '\"]', this.ContentSourceOverride).length) {
                    // restrict the selector to a specific context, if one has been targeted
                    outputSelector = '[data-if-context-wrapper=\"' + this.sourceContext + '\"] ';  //formatted so it can be easily prefixed
                }
                return outputSelector;
            }
        });

        /**
         * Defines the default.targetContextSelector if nlx.targetContext
         * is set and if nlx.ContentSourceOverride is set.
         *
         */
        Object.defineProperty(config, 'targetContextSelector', {
            get: function () {
                var outputSelector = this.sourceContextSelector || '';
                if (this.targetContext && $('[data-if-context-wrapper=\"' + this.targetContext + '\"]', this.ContentSourceOverride).length) {
                    // restrict the selector to a specific context, if one has been targeted
                    outputSelector = '[data-if-context-wrapper=\"' + this.targetContext + '\"] '; //formatted so it can be easily prefixed
                }
                return outputSelector;
            }
        });

        /**
         * Add the form action parameters to the base url.
         * @function
         * @returns {string} url
         */
        function _addFormActionParams(baseUrl) {
            var qs = $(config.sourceContextSelector + 'form', config.ContentSourceOverride).eq(0).attr('action');

            var result = baseUrl;

            if (config.targetVerb === 'POST' && qs) {
                qs = qs.replace('?', '');

                if (baseUrl.indexOf('?') > -1) {
                    result = baseUrl + '&' + qs;
                } else {
                    result = baseUrl + '?' + qs;
                }
            }
            return result;
        }

        function initialize(initconfig, loadExplicitTemplate) {

            var pushState = false,
                trimmedPage,
                trimmedTemplate,
                state,
                requestInfo;

            // merge initconfig object into config
            $.extend(config, initconfig);

            // assign config values
            config.callback = config.callback || null;
            config.currentTemplate = config.currentTemplate || '';
            config.debugMode = config.debugMode || false;
            config.followProposedTemplate = config.followProposedTemplate === false ? false : true;
            config.followProposedTemplateUseAJAX = config.followProposedTemplateUseAJAX || false;
            config.forceReload = config.forceReload || false;
            config.loadFromStorage = config.loadFromStorage === false ? false : true;
            config.manualRequestObj = config.manualRequestObj || undefined;
            config.previousScrollTop = $('body').scrollTop() || 0;
            config.redirectErrorResponseToMaintenancePage = config.redirectErrorResponseToMaintenancePage || false;
            config.scope = config.scope || '';
            config.sessionID = config.sessionID || 'InFlightViewer1';
            config.showLoading = config.showLoading === false ? false : true;
            config.simulate = config.simulate || false;
            config.simulationData = config.simulationData || '';
            config.sourceContext = config.sourceContext || undefined;
            config.targetContext = config.targetContext || undefined;
            config.targetPath = config.targetPath || '';
            config.targetSystem = config.targetSystem || '';
            config.targetVerb = (config.targetVerb || 'POST').toUpperCase();
            config.useSSO = config.useSSO || false;
            config.uploadBlob = config.uploadBlob || null;

            if (!config.targetUrl) {
                config.targetUrl = '/--IF/@@@TARGET_SYSTEM@@@/@@@SESSION_ID@@@/@@@USE_SSO@@@/DisplayLang=ENG/NLX3/FI--@@@TARGET_PATH@@@',
                    config.targetUrl = config.targetUrl.replace('@@@TARGET_SYSTEM@@@', config.targetSystem);
                config.targetUrl = config.targetUrl.replace('@@@SESSION_ID@@@', config.sessionID);
                config.targetUrl = config.targetUrl.replace('@@@TARGET_PATH@@@', config.targetPath);
                config.targetUrl = config.targetUrl.replace('@@@USE_SSO@@@', (config.useSSO ? '70' : '68'));
            }

            if (useSPA) {
                // assign config as global object
                self.window.ifReferenceWindow.nlxConfig = config;

                // call stateInit()
                stateInit();

                // NOTE: 2014-12-18 13:51
                // room to make function from current template
                //
                // currentTemplate never gets set here but is later assigned self.window.ifReferenceWindow.ifCurrentPage
                if (!config.currentTemplate) {
                    if (loadExplicitTemplate || config.trackTemplates) {
                        // pull this whole thing
                        config.currentTemplate = window.location.pathname;
                    }
                }

                //TODO: does this belong in $() -- so that it only fires once?

                if (!self.window.ifReferenceWindow.ifCurrentPage) {
                    // Set ifCurrentPage for the first time
                    self.window.ifReferenceWindow.ifCurrentPage = config.currentTemplate;
                    pushState = true;
                } else {
                    trimmedPage = self.window.ifReferenceWindow.ifCurrentPage.split('?', 1)[0].split('#', 1)[0];
                    trimmedTemplate = config.currentTemplate.split('?', 1)[0].split('#', 1)[0];
                    if (trimmedPage !== trimmedTemplate && !config.ContentSourceOverride) {
                        config.currentTemplate = self.window.ifReferenceWindow.ifCurrentPage;
                        pushState = true;
                    }
                }

                self.window.ifReferenceWindow.ifCurrentKey = generateKey();

                if (pushState) {
                    var statePage = (!loadExplicitTemplate) ? self.window.ifReferenceWindow.ifCurrentPage : document.referrer;
                    state = {
                        state: self.window.ifReferenceWindow.ifCurrentKey,
                        page: statePage,
                        key: self.window.ifReferenceWindow.ifCurrentKey,
                        scroll: $('body').scrollTop()
                    };

                    if(!InFlight.NLX.History || InFlight.NLX.History.filterState(state, location.href)){
                        self.window.ifReferenceWindow.History.pushState(state, null, statePage);
                    }
                }

            } // if (useSPA)

            if (loadExplicitTemplate && useSPA) {
                fetchTarget(loadExplicitTemplate, true);
            } else {

                requestInfo = {
                    TargetUrl: _addFormActionParams(config.targetUrl),
                    TargetContent: config.manualRequestObj || _scanForSources(),
                    CurrentTemplate: config.currentTemplate.split('?', 1)[0].split('#', 1)[0],
                    Callback: config.callback,
                    Data: null,
                    BeforeProcessResponse: config.beforeProcessResponse,
                    AfterProcessResponse: config.afterProcessResponse
                };

                if (!config.followProposedTemplate || !useSPA) {
                    requestInfo.CurrentTemplate = '';
                }

                _getData(requestInfo);
            }
        }

        function stateInit() {
            // Only called when in SPA mode
            var $bodyTarget,
                iframeString,
                State,
                currentConfig,
                returnLocation;

            if (!$('#pastFrame', CURRENTDOCUMENT).length) {
                $bodyTarget = $('body', CURRENTDOCUMENT);
                iframeString = '<iframe style="display:none" src="about:blank" id="pastFrame"></iframe>';
                $(iframeString).appendTo($bodyTarget);

                if (!self.window.ifReferenceWindow.pastPageTracker) {
                    self.window.ifReferenceWindow.pastPageTracker = [];
                }

                self.window.ifReferenceWindow.History.Adapter.bind(window, 'statechange', function (e) { // Note: We are using statechange instead of popstate
                    // Log the State
                    State = self.window.ifReferenceWindow.History.getState(); // Note: We are using History.getState() instead of event.state
                    self.window.ifReferenceWindow.History.log('statechange:', State.data, State.title, State.data.page);
                    if (moveHistoryContentIn(self.window.ifReferenceWindow.ifCurrentKey, State.data.key)) {
                        currentConfig = self.window.ifReferenceWindow.nlxConfig;
                        if (currentConfig.onStateChange) {
                            currentConfig.onStateChange(e, State);
                        } else if (self.window.nlxOnStateChangeGlobal) {
                            self.window.nlxOnStateChangeGlobal(e, State);
                        }
                        self.window.ifReferenceWindow.ifCurrentKey = State.data.key;
                        self.window.ifReferenceWindow.ifCurrentPage = State.data.page;
                    }
                });
            }
        }

        function _firstLoad(href) {
            initialize({}, href);
        }

        function fetchTarget(href, isExplicitTarget) {
            showLoading(true);
            // Only called when in SPA mode

            // NOTE: what is the point of useAjax?
            var useAjax = true,
                currentContentKey = self.window.ifReferenceWindow.ifCurrentKey,
                state,
                $currentContentTarget,
                $currentContentSource,
                $containerTarget,
                $bodyTarget,
                iframeString;

            if (href.indexOf('#nocache') > -1) {
                useAjax = false;
                href = href.replace('#nocache', '');
            }

            if (!useAjax) {
                self.window.ifReferenceWindow.location.href = href;
                return;
            }

            // NOTE: this looks like a repeat of assignments in initialize()

            // move the current page out
            if (isExplicitTarget) {
                // get rid of this container altogether
                $('.nlxContainer', CURRENTDOCUMENT).remove();
            } else {
                state = {
                    state: self.window.ifReferenceWindow.ifCurrentKey,
                    page: self.window.ifReferenceWindow.ifCurrentPage,
                    key: self.window.ifReferenceWindow.ifCurrentKey,
                    scroll: $('body').scrollTop()
                };

                console.log('replacing state for: ' + JSON.stringify(state));
                self.window.ifReferenceWindow.History.replaceState(state, null, state.page);

                $currentContentTarget = $('body', $('#pastFrame', CURRENTDOCUMENT)[0].contentWindow.document);
                console.log('Current Content Target is ' + (($currentContentTarget.length) ? 'found' : 'not found'));
                $currentContentSource = $('.nlxContainer', CURRENTDOCUMENT);
                console.log('Current Content Source is ' + (($currentContentSource.length) ? 'found' : 'not found'));
                $currentContentSource.appendTo($currentContentTarget).attr('id', currentContentKey);

                self.window.ifReferenceWindow.pastPageTracker.push(currentContentKey + ':' + state.page);
            }

            // load the new stuff in
            $('<div id="tempContainer"></div>').appendTo($('body', CURRENTDOCUMENT));

            self.window.ifReferenceWindow.ifCurrentPage = href;
            $('#tempContainer').load(_addParameter(href, 'useAjax', '1'), function () {
                $containerTarget = $('.nlxContainerMaster', CURRENTDOCUMENT).eq(0);
                $('.nlxContainer', $('#tempContainer')).appendTo($containerTarget);

                $('.nlxContainer').height('100%').css({
                    height: '100%',
                    display: 'none'
                });

                $('#tempContainer').remove();
                hideLoading();
            });

        }

        /**
         * Hides the page loader icon and shows the .nlxContainer
         *
         * @function
         */

        function hideLoading(duration) {
            if (numLoading > 0) {
                numLoading--;
            }
            if (numLoading === 0) {
                showNLXContainer();
                $(document).trigger('NLX:pageComplete');
            }
        }

        function showLoading(hideContainerWhileLoading) {
            numLoading++;
            if (config.showLoading) {
                $('#loadingContainer').show();  //doing loading and loadingContainer so that it is backwards compatible
                // $('#loading').show();
                if (!hideContainerWhileLoading) {
                    // $('.nlxContainer').hide();
                    $(document).trigger('NLX:pageStart');

                }
            }
        }

        function showNLXContainer() {
            $('#loadingContainer').hide(); //doing loading and loadingContainer so that it is backwards compatible
            // $('#loading').hide();
            $('.nlxContainer').show(); //show container once contents are rendered
            $(document).trigger('NLX:pageComplete');
        }

        // NOTE: lots of repeat content here. Room for some DRY functions
        function moveHistoryContentIn(currentContentKey, historyContentKey) {
            //only used in SPA mode
            var $historyContentSource = $('#' + historyContentKey, $('#pastFrame', CURRENTDOCUMENT)[0].contentWindow.document),
                $currentContentTarget,
                $currentContentSource,
                $historyContentTarget = $('.nlxContainerMaster');

            if (currentContentKey !== historyContentKey && $historyContentSource.length) {
                console.log('mhci');
                console.log('History Content Source is found');

                // move the current page content into the storage frame
                $currentContentSource = $('.nlxContainer', CURRENTDOCUMENT);
                console.log('Current Content Source is ' + (($currentContentSource.length) ? 'found' : 'not found'));
                $currentContentTarget = $('body', $('#pastFrame', CURRENTDOCUMENT)[0].contentWindow.document);
                console.log('Current Content Target is ' + (($currentContentTarget.length) ? 'found' : 'not found'));
                $currentContentSource.appendTo($currentContentTarget).attr('id', currentContentKey);

                // move the history content from the storage frame into the current page
                $historyContentSource.appendTo($historyContentTarget, CURRENTDOCUMENT).attr('class', 'nlxContainer');

                self.window.ifReferenceWindow.pastPageTracker.pop();

                showNLXContainer();

                return true;
            }
            console.log('History Content Source is not found');
            return false;
        }

        function randomString(length, chars) {
            var result = '';
            for (var i = length; i > 0; --i) {
                result += chars[Math.round(Math.random() * (chars.length - 1))];
            }
            return result;
        }

        function generateKey() {
            return randomString(16, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
        }

        function _getData(requestInfo) {
            showLoading();
            if (config.simulate && config.simulationData) {
                // use our simulated data
                _handleResponse(requestInfo, config.simulationData);
                hideLoading();
            } else {

                $.support.cors = true;

                var myContentType;
                var myProcessData;

                requestInfo.TargetVerb = 'GET';

                // Make anything with a UNIVERSAL context wrapper temporarily match our sourceContext
                var sourceContext = config.sourceContextSelector.replace('[data-if-context-wrapper=\'', '').replace('\'] ', '');
                $('[data-if-context-wrapper="UNIVERSAL"]').each(function () {
                    var $thisItem = $(this);
                    $thisItem.attr('data-if-universal-context', 'true');
                    $thisItem.attr('data-if-context-wrapper', sourceContext);
                });


                var $thisForm = $(config.sourceContextSelector + 'form', config.ContentSourceOverride);

                // Revert universal context wrappers
                $('[data-if-universal-context="true"]').each(function () {
                    var $thisItem = $(this);
                    $thisItem.removeAttr('data-if-universal-context');
                    $thisItem.attr('data-if-context-wrapper', 'UNIVERSAL');
                });

                if ($thisForm.length) {
                    if (config.targetVerb === 'POST' && $thisForm[0].children.length) {
                        requestInfo.TargetVerb = 'POST';
                    }
                }
                var ignoreContent = [];
                $('[data-if-xml-ignore=true]').each(function () {
                    var id = $(this).attr('id');
                    if (id) {
                        ignoreContent.push('[id="' + id + '"]');
                    }
                });

                requestInfo.Data = ['IF-TargetVerb=' + requestInfo.TargetVerb,
                    'IF-TargetContent=' + encodeURIComponent(JSON.stringify(requestInfo.TargetContent)),
                    'IF-Template=' + requestInfo.CurrentTemplate,
                    'IF-IgnoreContent=' + (ignoreContent.length > 0 ? encodeURIComponent(ignoreContent.join(',')) : ''),
                    //"IF-DebugMode=" + config.debugMode,
                    $thisForm.serialize()].join('&');

                // Look to see if we have to make adjustments for file uploading
                if (config.targetVerb === 'POST') {
                    if ($thisForm.length) {
                        // Prep the form slightly differently if we've got a file upload
                        var fileUpload = false;
                        $('input[type=file]').each(function () {
                            if (this.files.length) {
                                fileUpload = true;
                                return;
                            }
                        });

                        if (fileUpload) {
                            // put the attachments at the end (JLB 2015-10-31)
                            console.log('*** this is a NLX file upload ***');

                            $('body').append('<form id="attachmentForm"></form>');
                            $('#attachmentForm').append($('input[type=file]'));
                            requestInfo.Data = new FormData($thisForm[0]);
                            if ($thisForm.length > 1) {
                                for (var i = 1; i < $thisForm.length; i++) {
                                    var additionalFormData = $thisForm.eq(i).serializeArray();
                                    for (var j = 0; j < additionalFormData.length; j++) {
                                        requestInfo.Data.append(additionalFormData[j].name, additionalFormData[j].value);
                                        //console.log("-- upload param: " + additionalFormData[j].name + " " + additionalFormData[j].value);
                                    }
                                }
                            }
                            requestInfo.Data.append('IF-TargetVerb', requestInfo.TargetVerb);
                            requestInfo.Data.append('IF-TargetContent', encodeURIComponent(JSON.stringify(requestInfo.TargetContent)));
                            requestInfo.Data.append('IF-Template', requestInfo.CurrentTemplate);
                            //requestInfo.Data.append("IF-DebugMode", config.debugMode);

                            if (config.uploadBlob !== null) {
                                console.log('####### special blob! #########');
                                requestInfo.Data.append(config.uploadBlob.parameterName, config.uploadBlob.blob, config.uploadBlob.fileName);
                            }
                            else {
                                console.log('####### normal file input blob #########');
                                $('#attachmentForm input[type=file]').each(function () {
                                    requestInfo.Data.append(this.name, this.files[0]);
                                });
                            }

                            $('#attachmentForm').remove();

                            myContentType = false;
                            myProcessData = false;
                        }
                    }
                }


                console.log('AJAX - expecting json: ' + requestInfo.TargetUrl);

                $.ajax({
                    type: 'POST',
                    url: requestInfo.TargetUrl,
                    crossDomain: true,
                    processData: myProcessData, //undefined unless we're uploading a file
                    contentType: myContentType, //undefined unless we're uploading a file
                    xhrFields: { withCredentials: true },
                    data: requestInfo.Data,
                    /*
                    data: ["IF-TargetVerb=" + requestInfo.TargetVerb,
                        "IF-TargetContent=" + JSON.stringify(requestInfo.TargetContent),
                        "IF-Template=" + requestInfo.CurrentTemplate,
                        //"IF-DebugMode=" + config.debugMode,
                        requestInfo.Data
                        ].join("&"),
                    */
                    dataType: 'json',
                    /*
                    jsonp: false,
                    jsonpCallback: "func",
                    */

                    // TODO: change this to .done()
                    success: function (data, textStatus, xhr) {
                        if (xhr.status === 278) {
                            console.log('success 278');
                            //_processHttp278Response(data, textStatus, xhr, this);
                            showLoading();
                            _processHttp278Response(xhr, this);
                        } else if (xhr.status === 200 && xhr.responseText.indexOf('"IFLocation":"') > -1) {
                            console.log('200 > 278');
                            console.log('index: ' + xhr.responseText.indexOf('{"IFLocation":"'));
                            showLoading();
                            _processHttp278Response(xhr, this);
                        } else {
                            _handleResponse(requestInfo, data);
                            //$('body').data('nlxAjax', data);
                            $('body').scrollTop(config.previousScrollTop);
                        }
                        hideLoading();
                    },
                    error: function (xhr, ajaxOptions, thrownError) {

                        if (xhr.status === 278) {
                            console.log('error 278');
                            _processHttp278Response(xhr, this);
                        } else if (xhr.status === 500 && xhr.responseText.indexOf('"IFLocation":"') > 0) {
                            console.log('error 500 > 278');
                            _processHttp278Response(xhr, this);
                        } else {

                            if(unloaded && _isFireFox()){
                                console.log('page is being unloaded, not directing to maintenance page');
                                return;
                            }

                            console.log('error');
                            console.log(xhr.status);
                            console.log(xhr.statusText);
                            console.log(xhr.responseXML);
                            console.log(xhr.responseText);
                            if (thrownError) {
                                console.log(thrownError);
                            }

                            if (MAINTENANCE_PAGE && config.redirectErrorResponseToMaintenancePage) {
                                var _xhr = xhr || {};

                                var ifCurrentPage = undefined;
                                if(self.window.ifReferenceWindow){
                                    ifCurrentPage = self.window.ifReferenceWindow.ifCurrentPage;
                                }

                                var maintenancePageErrorData = {
                                    status: _xhr.status,
                                    statusText: _xhr.statusText,
                                    responseText: _xhr.responseText,
                                    targetURL: requestInfo.TargetUrl,
                                    targetVerb: requestInfo.TargetVerb,
                                    currentTemplate: requestInfo.CurrentTemplate,
                                    thrownError: thrownError,
                                    currentPage: ifCurrentPage,
                                    ts: Date()
                                };

                                sessionStorage.maintenancePageErrorData = JSON.stringify(maintenancePageErrorData);
                                self.window.ifReferenceWindow.location.href = MAINTENANCE_PAGE;
                            }
                        }
                        hideLoading();
                    }
                });
            }
        }

        /**
         * Sets and resets the context flags of Universal wrappers.
         *
         * @function
         */
        function setUniversalContext(context) {
            var universalContext = $('[data-if-universal-context="true"]'),
                contextWrapper = $('[data-if-context-wrapper="UNIVERSAL"]');

            // reset
            if (context === false) {
                universalContext.each(function () {
                    var $thisItem = $(this);
                    // remove the universal-context flag
                    $thisItem.removeAttr('data-if-universal-context');
                    // return wrapper context to universal
                    $thisItem.attr('data-if-context-wrapper', 'UNIVERSAL');
                });
                return;
            }

            // set
            contextWrapper.each(function () {
                var $thisItem = $(this);
                // add universal-context flag to universal wrappers
                $thisItem.attr('data-if-universal-context', 'true');
                // set wrapper context to target context
                $thisItem.attr('data-if-context-wrapper', context);
            });
        }


        function _processHttp278Response(xhr, nlx) {

            var cleanResponseText = xhr.responseText.substring(0, xhr.responseText.indexOf('}') + 1);
            var responseDirective = JSON.parse(cleanResponseText);
            if (responseDirective) {
                if (responseDirective.IFLocation) {
                    var processedIFLocation = _processNLXRedirect(responseDirective.IFLocation);
                    if (processedIFLocation.indexOf('/--IF/') === -1 && processedIFLocation.toLowerCase().indexOf('/nlx3') === -1) {
                        _processPageRedirect(processedIFLocation);
                        return;
                    }

                    if (processedIFLocation.indexOf('http://') !== 0 && processedIFLocation.indexOf('https://') !== 0) {
                        var urlHostAuthority = _getAuthorityFromUrl(nlx.url);
                        nlx.url = urlHostAuthority + processedIFLocation;
                    } else if(processedIFLocation.indexOf('oauth2') > -1) {
                        //if session expires and isn't handles correctly user gets
                        // sent into an infinite loop so let's have them start over and log in.
                        window.location.href = '/pages/BS3/login.aspx';
                        return;
                    }
                    //JLFIX:
                    try {
                        nlx.data = nlx.data.replace('IF-TargetVerb=POST', 'IF-TargetVerb=GET');
                        $.ajax(nlx);
                    }
                    catch (fileUploadErr) {
                        console.log('### nlx.data GET not replaced ' + fileUploadErr);
                        console.log(JSON.stringify(nlx));
                        //do nothing?
                    }
                }
            }
        }

        function _getHandlers(){
            if(InFlight && InFlight.NLX && InFlight.NLX.Cfg && InFlight.NLX.Cfg.Handlers){
                return InFlight.NLX.Cfg.Handlers;
            }
            return {};
        }

        function _processPageRedirect(url) {
            var handlers = _getHandlers();
            if( handlers.processPageRedirect ){
                handlers.processPageRedirect(url);
                return;
            }

            self.location.href = url;
        }

        function _processNLXRedirect(url) {
            var handlers = _getHandlers();
            if( handlers.processNLXRedirect ){
                return handlers.processNLXRedirect(url);
            }
            return url;
        }

        function _getAuthorityFromUrl(aUrl) {
            var parseUrlAnchor = document.createElement('a');
            parseUrlAnchor.href = aUrl;

            if (parseUrlAnchor.host) {
                return parseUrlAnchor.protocol + '//' + parseUrlAnchor.host;
            }
            return '';
        }


        function _handleResponse(requestInfo, data) {
            var targetContext = config.targetContextSelector.replace('[data-if-context-wrapper=\"', '').replace('\"] ', ''),
                retVal;

            // Make anything with a UNIVERSAL context wrapper temporarily match our targetContext
            setUniversalContext(targetContext);

            if (requestInfo.Callback) {
                requestInfo.Callback(data);
                // Revert universal context wrappers
                setUniversalContext(false);
                return;
            }

            if (requestInfo.BeforeProcessResponse) {
                $(document).trigger('NLX:pageStart');
                requestInfo.BeforeProcessResponse(data);
            }

            retVal = _processResponse(data, requestInfo.CurrentTemplate);
            if (retVal) {
                if (requestInfo.AfterProcessResponse) {
                    $(document).trigger('NLX:pageComplete');
                    requestInfo.AfterProcessResponse(data, config);
                    $('a[href^="/--IF"]').each(function () {
                        var $this = $(this);
                        var aHref = $this.attr('href');
                        $this.attr('href', _getAuthorityFromUrl(requestInfo.TargetUrl) + aHref);
                    });
                }

                //TODO: this might be able to be made more robust
                if (config.originalSourceContext) {
                    config.sourceContext = config.originalSourceContext;
                    config.originalSourceContext = null;
                }

                if (useSPA) {
                    //re-base the jQuery $ function
                    $ = self.window.ifReferenceWindow.$;
                }
            }
            // Revert universal context wrappers
            setUniversalContext(false);

        }

        function _processResponse(jsonArray, currentTemplate) {
            var thisHref = jsonArray.ProposedTemplate,
                scopeFilter = '',
                $dataSources;

            if (useSPA) {
                if (config.followProposedTemplate && currentTemplate !== null && thisHref && thisHref !== currentTemplate) {
                    console.log('Template change to: ' + thisHref);
                    sessionStorage.lastTemplateUrl = thisHref;
                    fetchTarget(thisHref);
                    return false;
                }

                if (config.forceReload && thisHref) {
                    fetchTarget(thisHref);
                    return false;
                }
            }

            if (config.scope) {
                scopeFilter = '[data-if-scope=\'' + config.scope + '\']';
            }

            var ignoreFilter = jsonArray.Info['IF-ContentIgnored'];

            var filterIgnoreValues = function () {
                var $this = $(this);
                if ($this.closest(ignoreFilter).length > 0) {
                    return false;
                }
                return true;
            };


            var itemsToRemove = $(config.targetContextSelector + scopeFilter + '[data-if-cloned-from]');

            if (ignoreFilter) {
                itemsToRemove = itemsToRemove.filter(filterIgnoreValues);

            }

            itemsToRemove.remove();

            $dataSources = $(config.targetContextSelector + scopeFilter + '[data-if-source]');

            if ($dataSources.length) {
                if (ignoreFilter) {
                    $dataSources = $dataSources.filter(filterIgnoreValues);
                }

                console.log('$dataSources:\n', $dataSources.filter(':not([data-if-container-label])'));
                console.log('jsonArray.CaptureResults:\n', jsonArray.CaptureResults);
                _applyValues($dataSources.filter(':not([data-if-container-label])'), jsonArray.CaptureResults, jsonArray);
            }

            return true;
        }

        function _applyValues($targetElementSet, captureResults) {

            if (window.isXML === true) {

                $targetElementSet = $targetElementSet.filter(':not([data-if-xml-ignore=true])');
            }

            if (captureResults) {
                $targetElementSet.each(function (targetElementSetIndex) {
                    var prepend,
                        findRegex,
                        replace,
                        $targetElement = $(this),
                        ifDataLabel = $targetElement.attr('data-if-label') || 'item' + targetElementSetIndex,
                        $clonedElement,
                        elements = [];


                    if (captureResults[ifDataLabel]) {
                        if (captureResults[ifDataLabel].length > 1) {
                            // We'll deal with the original element, so start this loop at element #1
                            // and clone the original element in order to deal with the multiple returns
                            // from its selector

                            // show the original
                            $targetElement.removeClass('if-hide');

                            // now, clean the targetElement to prep it for cloning
                            _processElementForCloning($targetElement);

                            for (var i = 0; i < captureResults[ifDataLabel].length; i++) {
                                $clonedElement = $targetElement.clone();
                                $clonedElement.appendTo($targetElement.parent());
                                // possible alternate insertion (alleviates indexing issues in native js;
                                // possibly resolves cloning issues where cloneable elements don't have a distinct, dedicated parent)
                                // $targetElement.before($clonedElement);
                                elements.push($clonedElement);
                            }

                            // now hide the original
                            $targetElement.addClass('if-hide');

                            //now that we have our clones, iterate over them
                            for (var j = 0; j < elements.length; j++) {
                                elements[j].attr('data-if-label', elements[j].attr('data-if-label') + '-' + j);
                                elements[j].attr('data-if-source', captureResults[ifDataLabel][j].Selector);
                                elements[j].attr('data-if-cloned-from', $targetElement.attr('data-if-label'));
                                elements[j].find('*[data-if-source]').each(function () {
                                    $(this).attr('data-if-cloned-from', $targetElement.attr('data-if-label'));
                                });

                                _applyValues(elements[j].find('*[data-if-source]'), captureResults[ifDataLabel][j].Children);

                                //Experimental
                                _applyValues(elements[j].find('*[data-if-source]'), captureResults);

                                prepend = $targetElement.attr('data-if-prependtext');
                                findRegex = $targetElement.attr('data-if-find');
                                replace = $targetElement.attr('data-if-replace');
                                _applyElementProperties(elements[j], captureResults[ifDataLabel][j].Properties, prepend, findRegex, replace);

                                // replace any innerHtml uses of @@@INDEX with the index of our iterator
                                if (elements[j].html().indexOf('@@@INDEX') > -1) {
                                    var thisHtml = elements[j].html();
                                    thisHtml = thisHtml.replace(/@@@INDEX/g, j);
                                    //elements[j].html(elements[j].html().replace(/@@@INDEX/g, j));
                                }

                                // now replace any @@@INDEX placeholders with the index of our iterator
                                $(elements[j][0].attributes).each(function () {
                                    this.nodeValue = this.nodeValue.replace(/@@@INDEX/g, j);
                                });
                            }
                        } else {
                            _applyValues($targetElement.find('*'), captureResults[ifDataLabel][0].Children);
                            findRegex = $targetElement.attr('data-if-find');
                            replace = $targetElement.attr('data-if-replace');

                            prepend = $targetElement.attr('data-if-prependtext');
                            _applyElementProperties($targetElement, captureResults[ifDataLabel][0].Properties, prepend, findRegex, replace);
                        }
                    } else {
                        // No value was found.  Reset the $targetElement to its defaultValue, if one was provided
                        _processMissingCapture($targetElement);
                    }
                });
            }
        }

        function _applyElementProperties($targetElement, elementProperties, prepend, findRegex, replace) {
            //start by unhiding
            $targetElement.removeClass('if-hide');
            $targetElement.removeClass('if-hide-v');
            var thisProp;
            if ($targetElement.attr('data-if-reset-default')) {
                // save off our defaults
                for (thisProp in elementProperties) {
                    var key = DATA_PREFIX + thisProp;
                    if (typeof ($targetElement.data(key)) === 'undefined') {
                        switch (thisProp) {
                            case 'text':
                                $targetElement.data(key, $targetElement.text());
                                break;
                            case 'html':
                                $targetElement.data(key, $targetElement.html());
                                break;
                            case 'value':
                                $targetElement.data(key, $targetElement.val());
                                break;
                            case 'checked':
                                $targetElement.data(key, $targetElement.prop(thisProp));
                                break;
                            case 'selected':
                                $targetElement.data(key, $targetElement.prop(thisProp) === 'selected');
                                break;
                            case 'disabled':
                                $targetElement.data(key, $targetElement.prop(thisProp));
                                break;
                            default:
                                $targetElement.data(key, $targetElement.attr(thisProp));
                                break;
                        }
                        if (typeof ($targetElement.data(key)) === 'undefined') {
                            $targetElement.data(key, NLX_NULL_ATTRIBUTE);
                        }
                    }
                }
            }

            for (thisProp in elementProperties) {
                switch (thisProp) {
                    case 'text':
                        var replacementText = elementProperties[thisProp];
                        if (replacementText === null || replacementText === undefined) {
                            replacementText = '';
                        }
                        // Clean any newline characters
                        replacementText = replacementText.replace(/(?:\\r)?\\n/g, '<br />');
                        if (prepend && replacementText) {
                            replacementText = prepend + replacementText.trim();
                        }
                        if (findRegex && replacementText && typeof (replace) !== 'undefined') {
                            var regParts = findRegex.match(/^\/(.*?)\/([gim]*)$/);
                            var regexp;
                            if (regParts) {
                                // the parsed pattern had delimiters and modifiers. handle them.
                                regexp = new RegExp(regParts[1], regParts[2]);
                            } else {
                                // we got pattern string without delimiters
                                regexp = new RegExp(findRegex);
                            }

                            replacementText = replacementText.replace(regexp, replace);
                        }

                        $targetElement.text(replacementText);

                        if ($targetElement[0] && $targetElement[0].tagName.toLowerCase() === 'textarea') {
                            $targetElement.val($targetElement.text());
                        }

                        break;
                    case 'html':
                        var replacementHtml = elementProperties[thisProp];
                        if (replacementHtml === null || replacementHtml === undefined) {
                            replacementHtml = '';
                        }
                        // Clean any newline characters
                        replacementHtml = replacementHtml.replace(/(?:\\r)?\\n/g, '<br />');
                        $targetElement.html(replacementHtml);
                        break;
                    case 'hidden':
                        if (elementProperties[thisProp]) {
                            if ($targetElement.attr('data-if-hider') === 'visibility') {
                                $targetElement.addClass('if-hide-v');
                            } else {
                                $targetElement.addClass('if-hide');
                            }
                        }
                        break;
                    case 'value':
                        var nodeType = $targetElement.prop('nodeName');
                        if (nodeType && nodeType.toLowerCase() === 'select' && !elementProperties[thisProp]) {
                            //for selects, setting a null value will cause the selected option to not show
                            break;
                        }
                        $targetElement.val(elementProperties[thisProp]);
                        break;
                    case 'checked':
                        $targetElement.prop(thisProp, elementProperties[thisProp]);
                        break;
                    case 'selected':
                        $targetElement.prop(thisProp, elementProperties[thisProp] === 'selected');
                        break;
                    default:
                        $targetElement.attr(thisProp, elementProperties[thisProp]);
                        break;
                }
            }
        }

        function _processElementForCloning($targetElement) {
            // reset this element
            _resetElementProperties($targetElement);

            // process descendants as well
            $targetElement.find('*[data-if-content]').each(function () {
                _resetElementProperties($(this));
            });

        }
        function _resetElementProperties($targetElement) {
            var content = $targetElement.attr('data-if-content');
            var elementProperties;
            if (content) {
                elementProperties = content.split(' ');
                for (var i = 0; i < elementProperties.length; i++) {
                    var thisProp = elementProperties[i].trim();
                    switch (thisProp) {
                        case 'text':
                            $targetElement.text('');
                            break;
                        case 'html':
                            $targetElement.html('');
                            break;
                        case 'value':
                            $targetElement.val('');
                            break;
                        case 'checked':
                            $targetElement.prop(thisProp, false);
                            break;
                        default:
                            $targetElement.removeAttr(thisProp);
                            break;
                    }
                }
            }
        }

        function _processMissingCapture($targetElement) {
            if (!$targetElement.attr('data-if-container-label')) {

                if ($targetElement.attr('data-if-reset-default')) {
                    _applyElementDefaults($targetElement);
                }
                // process descendants as well
                $targetElement.find('*[data-if-reset-default]').each(function () {
                    _applyElementDefaults($(this));
                });
            }

        }

        function _applyElementDefaults($targetElement) {
            $.each($targetElement.data(), function (key, value) {
                if (key.indexOf(DATA_PREFIX) === 0) {
                    var thisProp = key.replace(DATA_PREFIX, '');
                    var thisVal = $targetElement.data(key);
                    switch (thisProp) {
                        case 'text':
                            $targetElement.text(thisVal);
                            break;
                        case 'html':
                            $targetElement.html(thisVal);
                            break;
                        case 'value':
                            if (thisVal === NLX_NULL_ATTRIBUTE) {
                                thisVal = '';
                            }
                            $targetElement.val(thisVal);
                            break;
                        case 'checked':
                            if (thisVal === NLX_NULL_ATTRIBUTE) {
                                thisVal = false;
                            }
                            $targetElement.prop(thisProp, thisVal);
                            break;
                        default:
                            if (thisVal === NLX_NULL_ATTRIBUTE) {
                                $targetElement.removeAttr(thisProp);
                            } else {
                                $targetElement.attr(thisProp, thisVal);
                            }
                            break;
                    }
                    // clear out the data store
                    $targetElement.removeData(key);
                }
            });
        }
        function _applyAttributesFromConfiguration() {
            $(config.sourceContextSelector + '[data-if-key]').each(function (index) {
                // only grab top-level elements
                var thisKey = $(this).attr('data-if-key');
                var cfg = InFlight.NLX.Cfg;
                //if(cfg[thisKey].data-if-source
            });
        }

        function _scanForSources() {
            // Make anything with a UNIVERSAL context wrapper temporarily match our targetContext
            var targetContext = config.targetContextSelector.replace('[data-if-context-wrapper=\"', '').replace('\"] ', ''),
                elements = [],
                $topLevelElements,
                scopeFilter = '';


            if (config.scope) {
                scopeFilter = '[data-if-scope=\'' + config.scope + '\']';
            }

            $topLevelElements = $(config.targetContextSelector + scopeFilter + '[data-if-source]');

            setUniversalContext(targetContext);

            if ($topLevelElements.length > 0) {
                $topLevelElements.filter(':not([data-if-cloned-from])').filter(':not([data-if-container-label])').each(function (index) {
                    // only grab top-level elements
                    if (!$(this).attr('data-if-container-label')) {
                        elements.push(_getSourceElementRepresentation($(this), index));
                    }
                });
            }

            // Revert universal context wrappers
            setUniversalContext(false);
            return elements;
        }

        function _getSourceElementRepresentation($sourceObject, index) {
            var element = {
                Lbl: $sourceObject.attr('data-if-label') || 'item' + index,
                Src: $sourceObject.attr('data-if-source'),
                Data: $sourceObject.attr('data-if-content'),
                HWA: $sourceObject.attr('data-if-hide-when-absent') || undefined,
                HWP: $sourceObject.attr('data-if-hide-when-present') || undefined,
                Children: []
            };

            // check to see if this element has any child selectors
            $('[data-if-container-label="' + element.Lbl + '"]:not([data-if-cloned-from])', $sourceObject).each(function (childIndex) {
                element.Children.push(_getSourceElementRepresentation($(this), childIndex));
            });

            return element;
        }

        function _getParameterByName(name, url) {
            var a = url ? $('<a>', { href: url })[0] : window.location,
                param = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

            param = new RegExp('[\\?&]' + param + '=([^&#]*)');
            param = param.exec(a.search);
            param = param === null ? '' : decodeURIComponent(param[1].replace(/\+/g, ' '));
            return param;
        }

        function _addParameter(url, parameterName, parameterValue, atStart/*Add param before others*/) {
            var replaceDuplicates = true;
            var urlhash = '';
            var cl = url.length;

            if (url.indexOf('#') > 0) {
                cl = url.indexOf('#');
                urlhash = url.substring(url.indexOf('#'), url.length);
            }
            var sourceUrl = url.substring(0, cl);

            var urlParts = sourceUrl.split('?');
            var newQueryString = '';

            if (urlParts.length > 1) {
                var parameters = urlParts[1].split('&');
                for (var i = 0; (i < parameters.length); i++) {
                    var parameterParts = parameters[i].split('=');
                    if (!(replaceDuplicates && parameterParts[0] === parameterName)) {
                        if (newQueryString === '') {
                            newQueryString = '?';
                        }
                        else {
                            newQueryString += '&';
                        }
                        newQueryString += parameterParts[0] + '=' + (parameterParts[1] ? parameterParts[1] : '');
                    }
                }
            }
            if (!newQueryString) {
                newQueryString = '?';
            }

            if (atStart) {
                newQueryString = '?' + parameterName + '=' + parameterValue + (newQueryString.length > 1 ? '&' + newQueryString.substring(1) : '');
            } else {
                if (newQueryString !== '' && newQueryString !== '?') {
                    newQueryString += '&';
                }
                newQueryString += parameterName + '=' + (parameterValue ? parameterValue : '');
            }
            return urlParts[0] + newQueryString + urlhash;
        }

        function _escapeHtml(unsafe) {
            return unsafe
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        }
        function _addUploadBlob(aBlob, elementName, filename) {
            config.uploadBlob = { blob: aBlob, parameterName: elementName, fileName: filename };
        }

        function _isFireFox(){
            var userAgent = navigator.userAgent;
            if(userAgent){
                return userAgent.toLowerCase().indexOf('firefox') !== -1;
            }

            return false;
        }

        return {
            init: initialize,
            processResponse: _processResponse,
            escapeHtml: _escapeHtml,
            firstLoad: _firstLoad,
            getParameterByName: _getParameterByName,
            addUploadBlob: _addUploadBlob,
            fetchTarget: fetchTarget,
            showLoading: showLoading,
            hideLoading: hideLoading
        };
    };

})(jQuery);

var InFlightDC = new InFlightDCType();
var nlx = new InFlightDCType(false);

/* Remaining:

    o config.simulate / config.simulationData in  _getData()
    o adding _processHttp278Response
    sessionStorage.lastTemplateUrl = newHref; in _processResponse()
    look at the top of _processResponse

    sub in FS _getData() and 278 handler
*/
